import React from 'react'
import Helmet from 'react-helmet'
import { useParams } from 'react-router-dom'
import { sanitizeHtml } from '../../../utils/sanitizeHtml'
import { findMember } from '../members'

import './styles.css'

function TeamMember() {
  const { memberSlug } = useParams()
  const member = findMember(memberSlug)
  return (
    <div id="TeamMember">
      <Helmet>
        <title>{`${member.name} | Stan Winston School of Character Arts`}</title>
        <meta content="profile" property="og:type" />
      </Helmet>
      <div className="img-holder">
        <img src={member.landscapeImage} alt={member.name} />
      </div>
      <div className="member-info wrapper">
        <h1>{member.name}</h1>
        {member.bio && (
          <div
            className="bio"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(member.bio) }}
          />
        )}
      </div>
    </div>
  )
}

export default TeamMember
